import React from "react";
import { Alert } from "@material-ui/lab";
export const ExclVat = () => {
  return (
    <Alert
      severity={"info"}
      style={{ maxWidth: 300, padding: "0px 0px 0px 5px" }}
    >
      All numbers in this view are excl. vat
    </Alert>
  );
};
